import { useNavigate, useParams, generatePath } from "react-router-dom";

import searchIcon from "../../assets/img/searchIcon.png";
import Toolbar from "react-multi-date-picker/plugins/toolbar";
import DatePicker from "react-multi-date-picker";
import ClearIcon from "@mui/icons-material/Clear";
import { IconButton } from "@mui/material";
import AutocompleteInput from "./AutocompleteInput";
import Tooltip from "@mui/material/Tooltip";
import downloadIcon from "../../assets/img/excleExport.png";
function FilterSection(props) {
  const {
    setToolBar,
    toolbar,
    dropdown1Value,
    dropdown1Text,
    handleDropdown1Change,
    dropdown1Options,
    isdateRange,
    dateRange,
    setDateRange,
    isAnyFilterApplied,
    resetToolbar,
    dropdown2Value,
    dropdown2Text,
    handleDropdown2Change,
    dropdown2Options,
    dropdown3Value,
    dropdown3Text,
    handleDropdown3Change,
    dropdown3Options,
    dropdown4Value,
    dropdown4Text,
    handleDropdown4Change,
    dropdown4Options,
    button1Text,
    // button1Path,
    button2Text,
    button2Path,
    fetchDownloadExcel,
  } = props;

  const navigate = useNavigate();
  const { clientNameParam } = useParams();

  return (
    <>
      <div className="row py-3 align-items-center g-3">
        {/* Search Bar */}
        <div className="custom_toolbar_search col-12 col-md-3 ">
          <img src={searchIcon} style={{ left: "1rem" }} />
          <input
            type="text"
            className="form-control custom_toolbar_control"
            id="floatingInput"
            placeholder="Search..."
            value={toolbar.searchText}
            onChange={(e) =>
              setToolBar({ ...toolbar, searchText: e.target.value })
            }
          />
        </div>

        {/* Dropdowns */}
        {/* <div className="col-6 col-md-2">
                      <select
                        className="form-select custom_toolbar_control"
                        value={toolbar.propertyName}
                        onChange={(e) =>
                          setToolBar({ ...toolbar, propertyName: e.target.value })
                        }
                      >
                        <option value="Property Name">Property Name</option>
                        {[
                          ...new Set(
                            allPropertyList?.map((user) => user.propertyName)
                          ),
                        ].map((cityItem, index) => (
                          <option key={index} value={cityItem}>
                            {cityItem}
                          </option>
                        ))}
                      </select>
                    </div> */}

        {/* {dropdown1Options && (
          <div className="col-6 col-md-2">
            <select
              className="form-select custom_toolbar_control"
              value={dropdown1Value}
              onChange={(e) => handleDropdown1Change(e)}
            >
              <option value={dropdown1Text}>{dropdown1Text}</option>
              {[...new Set(dropdown1Options)].map((item, index) => (
                <option key={index} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>
        )} */}

        {dropdown1Options && (
          <div className="col-6 col-md-2">
            <AutocompleteInput
              masterList={
                [...new Set(dropdown1Options)].map((item) => ({
                  name: item,
                })) || []
              }
              getOptionLabel={(item) => item?.name || ""}
              getOptionValue={(item) => item?.name || ""}
              value={dropdown1Value === dropdown1Text ? "" : dropdown1Value}
              onValueChange={(value) =>
                handleDropdown1Change({
                  target: {
                    value: value || dropdown1Text,
                  },
                })
              }
              placeholder="Inspector(s)"
              inputClassName="form-control custom_toolbar_control mt-1"
              notFoundText={`${dropdown1Text} not found`}
            />
          </div>
        )}
        {isdateRange && (
          <div className="col-6 col-md-2">
            <DatePicker
              className=""
              value={dateRange}
              onChange={(range) => setDateRange(range || [null, null])}
              range
              format="DD/MM/YYYY"
              placeholder="Select date range"
              plugins={[
                <Toolbar
                  key={1}
                  position="bottom"
                  sort={["deselect", "close", "today"]}
                />,
              ]}
              style={{ width: "100%" }}
            />
          </div>
        )}

        {dropdown2Options && (
          <div className="col-6 col-md-2">
            <select
              className="form-select custom_toolbar_control"
              value={dropdown2Value}
              onChange={(e) => handleDropdown2Change(e)}
            >
              <option value={dropdown2Text}>{dropdown2Text}</option>
              {[...new Set(dropdown2Options)].map((item, index) => (
                <option key={index} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>
        )}

        {dropdown3Options && (
          <div className="col-6 col-md-2">
            <select
              className="form-select custom_toolbar_control"
              value={dropdown3Value}
              onChange={(e) => handleDropdown3Change(e)}
            >
              <option value={dropdown3Text}>{dropdown3Text}</option>
              {[...new Set(dropdown3Options)].map((item, index) => (
                <option key={index} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>
        )}

        {dropdown4Options && (
          <div className="col-6 col-md-2">
            <select
              className="form-select custom_toolbar_control"
              value={dropdown4Value}
              onChange={(e) => handleDropdown4Change(e)}
            >
              <option value={dropdown4Text}>{dropdown4Text}</option>
              {[...new Set(dropdown4Options)].map((item, index) => (
                <option key={index} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Clear Filters Button */}
        {isAnyFilterApplied && (
          <div style={{ width: "auto", paddingLeft: "0px" }}>
            <IconButton
              tabIndex={0}
              title="Clear Filters"
              onClick={() => {
                resetToolbar();
                if (dateRange && isdateRange) {
                  setDateRange([null, null]);
                }
              }}
            >
              <ClearIcon sx={{ color: "#717186" }} fontSize="small" />
            </IconButton>
          </div>
        )}

        {/* Export Button */}
        <div className="col-md-2 col-6 text-end ms-auto new-inspection-btn-toolbar">
          <Tooltip
            title="Export to excel"
            arrow
            slotProps={{
              tooltip: {
                sx: {
                  bgcolor: "#fff",
                  color: "#000",
                  fontSize: "12px",
                  boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
                },
              },
              arrow: {
                sx: {
                  color: "#fff",
                },
              },
            }}
          >
            <span>
              <button
                type="button"
                // style={{height: '33px', padding:'revert' }}
                className="btn btn-outline"
                // title="Export to excel"
                onClick={() => fetchDownloadExcel()}
              >
                <img src={downloadIcon}></img>
              </button>
            </span>
          </Tooltip>
          {button1Text && (
            <button
              className="btn ms-2 btn-primary custom_toolbar_btn"
              onClick={() =>
                navigate(
                  generatePath("/client/:clientNameParam/inspection", {
                    clientNameParam,
                  }),
                )
              }
            >
              <i
                className="fa fa-solid fa-plus"
                style={{ paddingRight: "0.3rem" }}
              ></i>
              {button1Text}
            </button>
          )}
          {button2Text && (
            <button
              className="btn btn-primary custom_toolbar_btn"
              onClick={() =>
                navigate(
                  generatePath(
                    { button2Path },
                    {
                      clientNameParam,
                    },
                  ),
                )
              }
            >
              <i
                className="fa fa-solid fa-plus"
                style={{ paddingRight: "0.3rem" }}
              ></i>
              {button2Text}
            </button>
          )}
        </div>
      </div>
    </>
  );
}

export default FilterSection;
